// To get esbuild to automatically bundle libraries that aren't neatly packaged
// into a single js file, we get them attached to the window object with the
// following:

window.stratego = window.stratego || {}

import ky from 'ky'
window.ky = ky

import { renderCamera } from './CameraWidget'
window.stratego.renderCamera = renderCamera

import { renderScanner } from './ScannerWidget'
window.stratego.renderScanner = renderScanner

import { renderModal } from './CamperAppModal'
window.stratego.renderModal = renderModal

